<template>
    <div>
    <nav class="navbar navbar-expand navbar-light" style="z-index: 100000;">
        <div class="container-fluid">
            <div class="navbar-item ml-3">
                <a href="#" v-if="(showBack || showHeaderBackButton) && !showSubHeaderPanel" @click.prevent="goBack()">
                    <!--<b-icon icon="chevron-left" class="text-dark" font-scale="2"></b-icon>-->
                    <b-img :src="require('@/assets/icons/chevron-left.png')" width="20" height="20" class="splash-back"></b-img>
                </a>
            </div>
            <div class="navbar-item">
                <b-img v-if="goHome || enableHeaderHomeButton" @click="goToHome()"
                    :src="require('@/assets/kontrol-sende.svg')" class="splash-logo"></b-img>
                <b-img v-else :src="require('@/assets/kontrol-sende.svg')" class="splash-logo"></b-img>
            </div>
            <div class="navbar-item mr-3">
                <a href="#" v-if="showHelp || showHeaderHelpButton" @click.prevent="goToFaqPage">
                    <b-icon icon="question-circle-fill" class="text-dark" font-scale="2"></b-icon>
                </a>
            </div>
        </div>
    </nav>
    <nav class="navbar navbar-expand navbar-light">
        <div class="container-fluid" v-if="(showSubHeader || showSubHeaderPanel) && (subHeader || subHeaderText)">
            <div class="navbar-item ml-3">
                <a href="#" v-if="showBack || showHeaderBackButton" @click.prevent="goBack()">
                    <!--<b-icon icon="chevron-left" class="text-dark" font-scale="2"></b-icon>-->
                    <b-img :src="require('@/assets/icons/chevron-left.png')" width="20" height="20" class="splash-back"></b-img>
                </a>
            </div>
            <div class="navbar-item">
                <span class="sub-header">{{ subHeader + subHeaderText }}</span>
            </div>
            <div class="navbar-item mr-3">
                &nbsp;
            </div>
        </div>

    </nav>
</div>
</template>

<script>

import { mapState } from 'vuex';

export default {
    name: 'Header',
    props: {
        showBack: {
            type: Boolean,
            default: false
        },
        showHelp: {
            type: Boolean,
            default: false
        },
        goHome: {
            type: Boolean,
            default: false
        },
        showSubHeader: {
            type: Boolean,
            default: false
        },
        subHeader: {
            type: String,
            default: ''
        },
    },
    components: {
        
    },
    data() {
        return {
            modalShow: false
        };
    },
    computed: {
        ...mapState(['showHeaderBackButton', 'showHeaderHelpButton', 'enableHeaderHomeButton', 'subHeaderText', 'showSubHeaderPanel'])
    },
    methods: {
        goBack() {
            //ev.preventDefault();
            this.$router.go(-1);
        },
        goToHome() {
            this.$router.push({ path: `/home` })
        },
        goToFaqPage() {
            this.$router.push({ path: `/faqs` })
        },
        showModal() {
            this.modalShow = true;
        },
        closeModal() {
            this.modalShow = false;
        },
        showBackButton() {
            this.showBack = true;
        },
        showHelpButton() {
            this.showHelp = true;
        },
        enableHomeButton() {
            this.goHome = true;
        }
    }
}
</script>

<style scoped>
nav {
    background-color: white;
}
.splash-logo {
    width: 176px;
}
.sub-header {
    color: #353535;
    font-size: 16px;
    font-weight: 500;
    line-height: 21.79px;
}
</style>